var _path, _polygon, _path2, _path3, _path4, _path5, _polygon2, _polygon3, _polygon4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-33",
    cx: 250,
    cy: 341.53,
    rx: 238.15,
    ry: 137.49,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-33",
    cx: 106.15,
    cy: 328.29,
    rx: 74.66,
    ry: 41.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-33",
    d: "M60.5,396.5l117,67.53a4.3,4.3,0,0,0,3.86,0l206.9-119.46a1.18,1.18,0,0,0,0-2.23l-117-67.53a4.28,4.28,0,0,0-3.85,0L60.5,394.27A1.18,1.18,0,0,0,60.5,396.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-33",
    cx: 384.73,
    cy: 393.4,
    rx: 63.83,
    ry: 36.85,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.29,362.14a1.66,1.66,0,0,1-1.66-1.67V253.7a1.66,1.66,0,1,1,3.32,0V360.47A1.67,1.67,0,0,1,113.29,362.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.35,323.27a1.68,1.68,0,0,1-1.55-1l-32.74-82.87a1.66,1.66,0,0,1,3.09-1.22L180.89,321a1.66,1.66,0,0,1-1.54,2.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.41,313.32a1.65,1.65,0,0,1-1.2-.52l-60.93-64.47L52.47,312.52a1.66,1.66,0,1,1-2.41-2.28l62-65.47a1.66,1.66,0,0,1,1.21-.52h0a1.66,1.66,0,0,1,1.2.52l62.13,65.75a1.65,1.65,0,0,1-.07,2.34A1.63,1.63,0,0,1,175.41,313.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.23,323.27a1.62,1.62,0,0,1-.61-.12,1.65,1.65,0,0,1-.94-2.15l32.74-82.87a1.66,1.66,0,0,1,3.09,1.22L48.77,322.22A1.66,1.66,0,0,1,47.23,323.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,310.76l4.33,11.42a1.55,1.55,0,0,1,0,.29v.21a1.41,1.41,0,0,1-.65.72,2.92,2.92,0,0,1-2.64,0,1.09,1.09,0,0,1-.51-.54v0l0-.15-4-10.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.48,310.76l-4.33,11.42a1.5,1.5,0,0,0,0,.29.74.74,0,0,0,0,.21,1.32,1.32,0,0,0,.65.72,2.9,2.9,0,0,0,2.63,0,1,1,0,0,0,.51-.54v0l0-.15L53,312Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,352.21v9.45a1,1,0,0,1-.56.78,3,3,0,0,1-2.71,0,1,1,0,0,1-.56-.78v-9.45A4.06,4.06,0,0,1,115.2,352.21Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,243.24c0-2.51-2.2-5.17-6.84-8.18-8.57-5.56-27.71-16.72-39.7-23.37a.11.11,0,0,0-.1-.09c-9.23-5.6-17.84-32.27-24.22-52.53-2.18-6.91-4.84-10.82-8-12.66-.75-.43-3.52-1.95-4.14-2.32-6.26-3.76-14.49.75-24.73,6.36-9.44,5.16-16.81,11.77-18.29,29.32-.91,10.68-.05,31.09,2.12,46.56h0c3.14,25.85,7,25.89,12.59,30.21C74.13,264,95.83,274.44,105,278c16.58,6.52,30.14-3.54,40.24-8.53A234.81,234.81,0,0,0,172,253.65c2.53-1.83,3.84-3.69,3.81-5.65C175.78,247.23,175.8,244.05,175.8,243.24Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,243.24c0-2.51-2.2-5.17-6.84-8.18-8.57-5.56-27.71-16.72-39.7-23.37a.11.11,0,0,0-.1-.09c-9.23-5.6-17.84-32.27-24.22-52.53-2.18-6.91-4.84-10.82-8-12.66-.75-.43-3.52-1.95-4.14-2.32-6.26-3.76-14.49.75-24.73,6.36-9.44,5.16-16.81,11.77-18.29,29.32-.91,10.68-.05,31.09,2.12,46.56h0c3.14,25.85,7,25.89,12.59,30.21C74.13,264,95.83,274.44,105,278c16.58,6.52,30.14-3.54,40.24-8.53A234.81,234.81,0,0,0,172,253.65c2.53-1.83,3.84-3.69,3.81-5.65C175.78,247.23,175.8,244.05,175.8,243.24Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.57,146.2c-6.21-3.26-14.28,1.17-24.26,6.64-6.39,3.51-11.84,7.66-15.15,15.43L53,165.83c3.31-7.74,8.75-11.89,15.12-15.38,10.25-5.61,18.47-10.12,24.74-6.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,235.06c-5.56-3.61-5.68-4.53-40-23.54a.5.5,0,0,1,.16.07c-9.22-5.62-17.82-32.27-24.2-52.52-6.49-20.58-17.3-14.62-32.63-6.22C62.87,158,55.5,164.62,54,182.17s1.75,61,7.74,66.3c6.53,7.22,32.74,20.64,43.21,24.76,16.58,6.52,30.14-3.54,40.24-8.53A235,235,0,0,0,172,248.85C177.73,244.67,177.2,240.4,169,235.06Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,211.59h0Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.31,152.85c15.33-8.4,26.14-14.36,32.63,6.22,6.38,20.26,15,46.93,24.22,52.53,0,0-15.83,0-38.76,12.37-23.84,12.87-27.48,25.46-28.57,24.56-6-5-9.3-48.82-7.81-66.36S62.87,158,72.31,152.85Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "179.54 328.1 74.52 267.47 249.93 166.25 354.94 226.88 179.54 328.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.52 267.47 74.52 388.73 80.05 391.92 80.05 308.95 174.01 363.2 174.01 446.17 179.54 449.36 179.54 328.1 74.52 267.47",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80.05 391.92 85.58 388.73 85.58 312.14 80.05 308.95 80.05 391.92"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "179.54 449.36 185.07 446.17 185.07 363.2 349.42 268.37 349.42 351.34 354.94 348.15 354.94 226.88 179.54 328.1 179.54 449.36",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.42 351.34 343.89 348.15 343.89 271.56 349.42 268.37 349.42 351.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170,304.18c-5.37,3.09-5.37,8.11,0,11.21s14,3.09,19.41,0,5.36-8.12,0-11.21S175.38,301.08,170,304.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.46,267.4,131,289.67a2.37,2.37,0,0,0,2.17,0l28.39-16.39a.66.66,0,0,0,0-1.25L123,249.75a2.44,2.44,0,0,0-2.17,0l-28.39,16.4C91.86,266.49,91.86,267.05,92.46,267.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.46,271.38,131,293.65a2.37,2.37,0,0,0,2.17,0l28.39-16.39c.6-.35.6-.91,0-1.25L123,253.73a2.44,2.44,0,0,0-2.17,0L92.46,270.12A.67.67,0,0,0,92.46,271.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,270.08,131,292.35a2.37,2.37,0,0,0,2.17,0L161.6,276c.6-.35.6-.91,0-1.25L123,252.43a2.44,2.44,0,0,0-2.17,0L92.46,268.82A.67.67,0,0,0,92.46,270.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,252.43,93.89,268,131,289.45a2.44,2.44,0,0,0,2.17,0l27-15.57L123,252.43A2.44,2.44,0,0,0,120.85,252.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,266.16,131,288.43a2.37,2.37,0,0,0,2.17,0L161.6,272a.67.67,0,0,0,0-1.26L123,248.51a2.37,2.37,0,0,0-2.17,0L92.46,264.9A.67.67,0,0,0,92.46,266.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136,247.6l20.85,12.07a2.82,2.82,0,0,0,2.56,0L226.7,220.8a.78.78,0,0,0,0-1.48l-20.84-12.07a2.84,2.84,0,0,0-2.57,0L136,246.12A.78.78,0,0,0,136,247.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,244.77v-.47a2.58,2.58,0,0,1,1.18-2l61.78-35.7a2.59,2.59,0,0,1,2.36,0l19.14,11.08a2.62,2.62,0,0,1,1.18,2v.47a2.6,2.6,0,0,1-1.18,2l-61.78,35.7a2.59,2.59,0,0,1-2.36,0L137.9,246.81A2.62,2.62,0,0,1,136.72,244.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,243.62,157,254.7a2.65,2.65,0,0,0,2.36,0L221.18,219a.72.72,0,0,0,0-1.36L202,206.56a2.59,2.59,0,0,0-2.36,0l-61.78,35.7A.72.72,0,0,0,137.9,243.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.58,310.58c4.73-4.83,7.51-16.9,2.89-20.73H168c-4.62,3.83-1.84,15.89,2.89,20.72l.13.14.16.16.43.38.11.09.36.27c.2.14.41.27.61.39a15.59,15.59,0,0,0,14.11,0h0a5.81,5.81,0,0,0,.61-.4l.34-.25.14-.11c.14-.12.28-.24.41-.37l.19-.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,288.31c-5.37,3.09-5.37,8.11,0,11.21s14,3.09,19.41,0,5.36-8.12,0-11.21S175.38,285.21,170,288.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,290.5c-3.26,1.89-3.26,4.94,0,6.82a13,13,0,0,0,11.81,0c3.26-1.88,3.26-4.93,0-6.82A13.07,13.07,0,0,0,173.82,290.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.63,293.74a13.07,13.07,0,0,0-11.81,0,5.47,5.47,0,0,0-2,1.79,5.47,5.47,0,0,0,2,1.79,13,13,0,0,0,11.81,0,5.35,5.35,0,0,0,2-1.79A5.35,5.35,0,0,0,185.63,293.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54,295.53a26.69,26.69,0,0,1-4.27-5.68c-2-3.49-2.34-8.16-1.32-8.74s5.17,4.09,5.17,4.09a25.49,25.49,0,0,1-.44-6c.18-3.11.93-5.93,1.82-6.5s2.89,3.35,3.74,6.19,1.36,5.18,1.36,5.18a45.11,45.11,0,0,1,1.53-6.54c1-2.95,2-3.62,2.71-3.32s1.21,1.66,1.42,5.59a38.42,38.42,0,0,1-.18,5.62s1.47-1.61,3.09-3.17c1.79-1.71,2.55-2,3.06-1.62s.65,3-2.11,8a28,28,0,0,1-5.22,6.87S181.07,298,174.54,295.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,238.4l5-60.24a5.68,5.68,0,0,0-2.49-5,6.3,6.3,0,0,0-5.7.1l-66,38.09a7.26,7.26,0,0,0-3.22,5.09l-5,60.23a5.71,5.71,0,0,0,2.48,5,6.32,6.32,0,0,0,5.71-.11l66-38.08A7.28,7.28,0,0,0,277,238.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,238.4l5-60.24a5.68,5.68,0,0,0-2.49-5,6.3,6.3,0,0,0-5.7.1l-66,38.09a7.26,7.26,0,0,0-3.22,5.09l-5,60.23a5.71,5.71,0,0,0,2.48,5,6.32,6.32,0,0,0,5.71-.11l66-38.08A7.28,7.28,0,0,0,277,238.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,238.4l5-60.24a5.68,5.68,0,0,0-2.49-5,6.3,6.3,0,0,0-5.7.1l-66,38.09a6.59,6.59,0,0,0-2.14,2.16l10.25,5.92v57.44l57.86-33.4A7.28,7.28,0,0,0,277,238.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,238.4l5-60.24a5.68,5.68,0,0,0-2.49-5,6.3,6.3,0,0,0-5.7.1l-66,38.09a6.59,6.59,0,0,0-2.14,2.16l10.25,5.92v57.44l57.86-33.4A7.28,7.28,0,0,0,277,238.4Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.12,279.88l5-60.23a7.25,7.25,0,0,1,3.22-5.09l66-38.09c1.63-.94,2.82-.18,2.67,1.69l-5,60.24a7.28,7.28,0,0,1-3.22,5.09l-66,38.08C206.16,282.51,205,281.75,205.12,279.88Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.12,279.88l5-60.23a7.25,7.25,0,0,1,3.22-5.09l66-38.09c1.63-.94,2.82-.18,2.67,1.69l-5,60.24a7.28,7.28,0,0,1-3.22,5.09l-66,38.08C206.16,282.51,205,281.75,205.12,279.88Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,231.55c.26-3.08,2.42-6.71,4.83-8.11s4.16,0,3.9,3.05-2.41,6.72-4.82,8.12S238.91,234.64,239.16,231.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.71 249.76 256.93 240.34 254.17 238.75 237.96 248.17 240.71 249.76",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "240.71 249.76 256.93 240.34 254.17 238.75 237.96 248.17 240.71 249.76",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,268l-19.74,11.4a2.45,2.45,0,0,1-1.27.29,2.49,2.49,0,0,1-1.07-.27s0,0,0,0l-8.69-5-.05,0a2.59,2.59,0,0,1-1.12-2v-.46c0-.75.51-1.06,1.17-.68l5.25,3,1.17.68-.26-1.33L238,248.17l2.75,1.6,16.22-9.42L265.38,266A2.06,2.06,0,0,1,264.45,268Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.45,268l-19.74,11.4a2.45,2.45,0,0,1-1.27.29,2.49,2.49,0,0,1-1.07-.27s0,0,0,0l-8.69-5-.05,0a2.59,2.59,0,0,1-1.12-2v-.46c0-.75.51-1.06,1.17-.68l5.25,3,1.17.68-.26-1.33L238,248.17l2.75,1.6,16.22-9.42L265.38,266A2.06,2.06,0,0,1,264.45,268Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "232.84 271.09 239.57 267.2 240.94 276.27 232.84 271.09",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.84 271.09 239.57 267.2 240.94 276.27 232.84 271.09"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,249.77l-2.75-1.6,1.85,25.39c.15.73-.27,1-.91.65l-5.25-3c-.66-.38-1.17-.07-1.17.68v.46a2.59,2.59,0,0,0,1.12,2l.05,0,8.69,5s0,0,0,0a2.49,2.49,0,0,0,1.07.27Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.71,249.77l-2.75-1.6,1.85,25.39c.15.73-.27,1-.91.65l-5.25-3c-.66-.38-1.17-.07-1.17.68v.46a2.59,2.59,0,0,0,1.12,2l.05,0,8.69,5s0,0,0,0a2.49,2.49,0,0,0,1.07.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-33",
    points: "166.85 266.42 169.89 268.17 193.87 254.13 196.52 251.01 191 252.47 166.85 266.42",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,250.34l5.11-1a.16.16,0,0,1,.15.26L193,253.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.48,249.6a.16.16,0,0,0-.15-.26l-1,.19h0a.87.87,0,0,1,.41.82v.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,264.44l.42-.24.51-.28L193,253.52a2.31,2.31,0,0,0-.14-1.69,2.4,2.4,0,0,0-1.65-1.49l-18.11,10.39-1,.55C172.79,261,174.6,264.11,174,264.44Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,263.54l.93-.54c.27-.15.12-.82-.21-1.52-.42-.93-1.26-1.83-1.63-1.64l-.68.4-.25.14c.37-.19,1.21.71,1.63,1.64.31.67.47,1.32.23,1.5h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.79,263.4c.64-.34-1.19-3.5-1.84-3.16l-.93.54c.64-.34,2.47,2.82,1.83,3.16Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,264.44l.93-.52c.63-.33-1.12-3.39-1.78-3.19h0l-.93.54C172.79,261,174.6,264.11,174,264.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5,249.42l-.17-.08-3.71,2-19.17,11c0-.06-.06-.06-.08,0,.54.85.95,1.92.59,2.1l.42-.24.51-.28L193,253.52h0l3.47-3.92A.17.17,0,0,0,196.5,249.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,266.69l3.91-2.25c.28-.14.13-.81-.19-1.5-.42-.94-1.26-1.84-1.63-1.66h0l-3.93,2.25c-.78.45-.06,2.15.81,2.9A.93.93,0,0,0,170.05,266.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,265.47a2.8,2.8,0,0,0-1.6-1.93.6.6,0,0,0-.58.08c-.59.54.09,2.1.92,2.81a.93.93,0,0,0,1,.26C170.32,266.52,170.43,266.07,170.28,265.47Z",
    style: {
      opacity: 0.1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.06,79.8a1.28,1.28,0,0,0-.63-.16H297l-4.72,2.72V98.69L297,96l4.07-4.7V102.8l4.72-2.72,12.36-13.3a1.26,1.26,0,0,0-.32-1.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.09,102.8l4.72-2.72,12.36-13.3a1.25,1.25,0,0,0-.95-2.07H305.81l-4.72,2.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,71.23a10,10,0,0,0-4.52-7.84h0a10,10,0,0,0-9.06,0l-34.41,19.7a10,10,0,0,0-4.53,7.85v37.15a10,10,0,0,0,4.53,7.84h0a10,10,0,0,0,9.06,0l34.84-20c4.07-2.32,4.11-4.65,4.11-7.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.32,128.09a10,10,0,0,0,4.53,7.84h0a10.17,10.17,0,0,0,8.29.38c-2.13.8-3.76-.42-3.76-3V96.16a9.26,9.26,0,0,1,1.33-4.46l-9.06-5.22a9.24,9.24,0,0,0-1.32,4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,70c-.53-1.93-2.29-2.54-4.38-1.33L266.9,88.32a9,9,0,0,0-3.19,3.38l-9-5.21a9.09,9.09,0,0,1,3.19-3.39l34.4-19.7a10.06,10.06,0,0,1,9.07,0h0A10,10,0,0,1,305.7,70Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.62 116.06 280.5 120.75 280.5 88.25 288.62 83.56 288.62 116.06",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.75 89.7 296.75 100.53 272.38 114.6 272.38 103.77 296.75 89.7",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.35,116.69c8,.22,10.27,3.42,15.09,10.31s21.22,33,21.22,33l23.23,8.92-3.06,13.55s-31.05-5.26-33.08-6.45-17.15-26.1-17.15-26.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,116.91c7.56-1.89,10.9,2.33,13.42,7,11.45,21,16.1,147,16.1,147s-25.54,10.19-44.49-1.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.58,333.48l-4.78,18.19s-5.51,3.25-10.26.05c-3.77-2.54-3.54-5.55-3.54-5.55l.22-2.74.54-21.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.58,356c-1.31,2.91-2.06,11.41-2.06,11.41s.8,3.13,5.15,5.9l4.23-11.24Z",
    style: {
      fill: "#263238"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.67 373.35 388.66 371.84 392.84 363.09 380.11 366.87 377.67 373.35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,348.52l.59-2.22c1.67.09,1.52,3.39,1.64,4.35.37,2.75.65,5.5,1.07,8.24a51.32,51.32,0,0,0,2.11,8.93c1,2.77,1.58,5.72,3.27,8.17s4.66,3.9,7.06,5.55a4.06,4.06,0,0,1,1.52,1.53c.55,1.22-.22,2.63-1.17,3.56a11.4,11.4,0,0,1-6.09,2.94,23.47,23.47,0,0,1-6.85,0,24.47,24.47,0,0,1-11.24-4.16c-3.22-2.3-3.92-6.85-4.44-10.53-.42-3-.16-6.49-1.4-9.3s-4.78-6.5-5.12-9.54a14.49,14.49,0,0,1,1.58-7.44c1.29-2.47,2.22-5.62,3.06-5.17l-.15,1.8c0-.13.83,3.46,6,4.74C387.5,350.58,392.09,350.56,393.63,348.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.8,368.22c.14,3.36,0,4.75,0,6.27.14,2.78.88,4.71,1.51,7.41a17,17,0,0,0,1.14,3.22c.52,1.2,1.49,2.82.92,4a4.57,4.57,0,0,1-1.14,1.41,10.67,10.67,0,0,1-7.5,2.55,8,8,0,0,1-4.08-1.17c-2.41-1.58-3.36-4.46-4.65-6.89-1.41-2.63-.59-4-.82-6.89a101.39,101.39,0,0,0-1.49-11.39C374.9,360.78,379.28,366.56,385.8,368.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,202c7.81,27.22,21,73.48,17.3,87.88-2.8,10.79-15,50.19-15,50.19-4.71.66-14.34,1.71-18.09-6.54-.95-13.39-4.25-104.31-4.25-104.31Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,202c7.81,27.22,21,73.48,17.3,87.88-2.8,10.79-15,50.19-15,50.19-4.71.66-14.34,1.71-18.09-6.54-.95-13.39-4.25-104.31-4.25-104.31Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.78,229.17a140.23,140.23,0,0,0,13.79-15.08s-1,6.45-9.89,15.34c0,0,14.9,57.39,14.81,66.55s-5,42-5,42Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,202c-6.37,13.21-8.87,18.49-20,27.22,0,0,13.61,56.56,14.21,67.54,1,18.25-1.35,59.1-2.19,71.51-2.11,2.76-12.39,3.23-15.63.88-1.48-5.74-6.45-25.94-8.78-44.06-1.72-13.39.48-25.37.76-28.88-7.21-18.39-23.4-45.23-29.32-64.46A48.77,48.77,0,0,1,331,221.54c-1.32-12.19,3.67-21.5,6.6-28L393.78,202",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.78,202c-6.37,13.21-8.87,18.49-20,27.22,0,0,13.61,56.56,14.21,67.54,1,18.25-1.35,59.1-2.19,71.51-2.11,2.76-12.39,3.23-15.63.88-1.48-5.74-6.45-25.94-8.78-44.06-1.72-13.39.48-25.37.76-28.88-7.21-18.39-23.4-45.23-29.32-64.46A48.77,48.77,0,0,1,331,221.54c-1.32-12.19,3.67-21.5,6.6-28L393.78,202",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.59,387.35c-.79,3.08-.07,11.57-.07,11.57s1.31,2.94,6.06,4.93l2.25-11.78Z",
    style: {
      fill: "#263238"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.58 403.85 385.14 400.48 387.75 391.17 375.88 397.05 374.58 403.85"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.76,376.7l.08-2.21c1.42.71,4.47,12.24,8.65,20.18,3.82,7.24,11.48,11.32,13.95,14.48,3.3,4.23-3.24,9.58-13.65,7.26-5.16-1.16-13-4.54-15.06-8.05s-2.76-9.93-4.47-12.51-5.82-5.57-6.67-8.5a15.93,15.93,0,0,1,.09-8.07c.84-2.65.8-5.37,2.13-5.59l.2,2.08c.69,1.43,3.39,3.07,8.65,3.41C382.17,379.33,384.6,379,385.76,376.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,94.14l-5.25,17.75c-14.6,0-23.62-14.22-23.62-28.82h0c0-14.66,9.34-26.91,24-26.91h4.76c14.66,0,26.55,9.73,26.55,24.4h0C393.78,90.11,381.94,94.14,367.34,94.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,67a10.63,10.63,0,0,0,1.55-6.1A7.09,7.09,0,0,0,395,55.51c-2.73-1.74-6.51-.92-9,1.09a7.39,7.39,0,0,0-7.9-6.59c-2.43.19-4.59,1.54-6.69,2.76A35.13,35.13,0,0,1,360,56.28L364.47,58a7.33,7.33,0,0,0-.78,6.39,7.1,7.1,0,0,0,.7,1.23,30,30,0,0,0,27.34,13.23,8.76,8.76,0,0,0,4.24-1.2,6.87,6.87,0,0,0,1.87-2A7.56,7.56,0,0,0,399.15,71,4.89,4.89,0,0,0,396.52,67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,119l-9.57,1c-6.35,1.55-9.22,4.35-9.87,10-.3,2.62-1.89,9.6.33,18.35,2,7.92,7.38,27.31,7.38,27.31S337.26,193.09,334,202c22.58,14.73,50.45,8.91,59.81,0-.79-8.42-3.77-16.27-4.44-23.78,0,0,.48-11.74,1.41-16.83,7.15-7.79,6.23-15.25,3-21.26-5.92-11.11-14.85-20.86-17.73-20.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,112.69c2.86.7,5.09,1.86,6.25,4s10.21,16.39,10.21,16.39-7.3-9.61-12.8-12.52a9.4,9.4,0,0,0-3.66-1.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,119s10,20.85,11.78,34.92-2,62.07-2,77.3c0,18.36.06,48.66.06,48.66s-11.41,0-19.25-2.24c-5.73-1.63-12.52-4.56-16.63-9.47,0,0-1.12-37.58,1.24-55.48,2.23-17,11.28-37.94,11.28-37.94l-11.6-44.22s.54-7.6,7.69-9.73C345.28,118.76,355.94,119,355.94,119Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.53,128.1l-11.84,17.33,7.69,29.3s-7.14,15.07-9.77,29.66c7.13-20.17,13.57-26.22,13.57-26.22L342,161.11s1.47-5.37,3.52-14.53S347.23,132.11,346.53,128.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,144.44c0-.87-.08-2.75-.23-5.13-.74-11.61-1.08-22.11,2.84-23l.35,1.6c-2.87.62-1.92,15.61-1.56,21.25.16,2.43.28,4.34.24,5.3Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,112.69a4,4,0,0,0-3.53,2.16c-.94,1.6-2.92,4.29-2.92,4.29s-.07,10.66,1,13.43c.92,2.4,12.22,11.29,12.22,11.29s-1.1,9.41-1.19,12.7,5.71,15.22,6.42,21.61c0,0,1.2-15.52.26-22.73-1.65-12.55-9.48-31.32-12.26-36.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.63,183.27h-.14l0-1.14a7.44,7.44,0,0,0,3.76-1.4,14.17,14.17,0,0,1-3.12-2.83c-1.85-2.39-5.89-19.44-4.64-23.41,1-3.33,4.31-10.68,7.23-10.8h.07c2.91,0,6.73,6.94,8.05,10.14,1.58,3.86-1,21.19-2.64,23.72a13.93,13.93,0,0,1-2.87,3.09,7.24,7.24,0,0,0,3.86,1.08l.14,1.13a8.83,8.83,0,0,1-5-1.45A9.13,9.13,0,0,1,350.63,183.27Zm3.21-38.45h0c-1.71.07-4.78,5.52-6.18,10-1.15,3.65,2.74,20.15,4.45,22.37A13.54,13.54,0,0,0,355.3,180a13.46,13.46,0,0,0,3-3.09c1.52-2.35,4-19.12,2.53-22.66C359.05,150,355.56,144.82,353.84,144.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,182.2a1.68,1.68,0,1,1-1.75-1.61A1.69,1.69,0,0,1,362,182.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.19,182.62a1.68,1.68,0,1,1-1.75-1.61A1.68,1.68,0,0,1,352.19,182.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.16,161.34l-1-.07a.36.36,0,0,1-.34-.4c.19-3.2.09-5.56-.3-6.5-1.7-4.14-5.2-9.32-6.73-9.26s-4.59,5.53-5.93,9.8c-.3,1-.21,3.33.26,6.5a.38.38,0,0,1-.31.43l-1,.15a.38.38,0,0,1-.43-.33c-.53-3.56-.59-6-.2-7.27.72-2.28,4.09-10.85,7.49-11s7.49,8.11,8.4,10.33c.5,1.22.65,3.66.42,7.26A.38.38,0,0,1,362.16,161.34Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,248.5c1.74,1.63,2.69,3.82,4.48,7.06s10.62,3.55,11.32-5.56c.53-6.86-1.87-9.18-6.68-14.52-5.05-5.62-7-6.54-6.77-11.75.13-2.57,4-39.77,4-39.77l12.73-35.07s4.6-16.39,2.29-27.81c0,0-8.25-.67-14.08,5.15-6.81,6.8-14.52,40.42-16.22,47.21a84.65,84.65,0,0,0-3.17,26.48c.4,10.91.44,33.71,1.89,38.74S318.05,244.11,322.74,248.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,119.57s-8.77-.55-13.9,3.65-8.32,15.94-12.09,27.67-7.13,23.16-8.37,31.38c-1,6.88,1,43.2,1,43.2s5.84,2.12,13.77-1.74L330,184l14.7-39.88A38,38,0,0,0,344.68,119.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.85,69.56c6.68.69,12.26,7.79,11.89,23.9-.32,13.66-4.75,17-7,18s-6.51,1.13-10.67.43v7.45s4.8,10.58,2.76,14.36C364.44,129,355.94,119,355.94,119V102.12s-2.81,3.33-7.41.28-4.78-10.62-2.1-13.34,8.44-1.85,9.51,1.9c0,0,4-.1,11.37-5.35A29,29,0,0,0,378.85,69.56Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.19,88.22a1.84,1.84,0,0,1-1.72,2,1.89,1.89,0,1,1,1.72-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.11,101l5.42,1.73a2.79,2.79,0,0,1-3.52,1.94A3,3,0,0,1,374.11,101Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,84l-3.68-2.55a2.15,2.15,0,0,1,3.06-.62A2.33,2.33,0,0,1,388.3,84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,87.87a1.82,1.82,0,1,1-1.91-1.8A1.85,1.85,0,0,1,387,87.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.77 86.83 378.06 97.77 383.82 95.99 377.77 86.83",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,111.89c-4.4-.57-13.43-3.91-14.84-7.49a9.24,9.24,0,0,0,3.17,4.56c2.7,2.32,11.67,4.92,11.67,4.92Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.55 155.48 403.07 176.17 391.11 227.91 392.08 228.94 433.41 208.15 447.52 156.51 446.55 155.48",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.05 177.21 392.08 228.94 391.11 227.91 403.07 176.17 404.05 177.21",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.52 156.51 404.05 177.21 392.08 228.94 433.41 208.15 447.52 156.51",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M427,197.63c.4,1,3.73,3.26,8.56,2.86l.81-3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M434.42,167.11l.36-1.73c.2-1-2.35-.46-5.7,1.12l-6.4,3c-3.35,1.58-6.22,3.64-6.42,4.6l-.36,1.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437.06,159c.13-.6-.91-.53-2.31.16l-2.53,1.24s.75-3.75-4.88-1.3-6.85,6.78-6.85,6.78l-2.71,1.35c-1.5.74-2.85,1.84-3,2.44l-.32,1.1,22.39-10.65S436.94,159.6,437.06,159Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.68,162.59c-2.05.93-2.91,1.39-3.21,2.87-.35,1.68-.49,2.9-.49,2.9l-9.92,4.72s.48-2.14.63-3-.18-1.24-1.76-.48l-.62-1.74,16-7.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,167.14s.16-.78.36-1.73-2.35-.46-5.7,1.12l-6.41,3c-3.34,1.58-6.21,3.64-6.41,4.6l-.36,1.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.68,174.21s-1.54,5.68-1.94,7.11-7.52,4.72-11.09,5.17c-6.82.85-7.59,2.33-5.95,7.17,1.51,4.46,5.95,6.15,12.11,5.42,2.88-.34,6.87-2.9,8.44-7.37,2-5.7.92-11.8,1.71-15.13S444.42,172.23,442.68,174.21Z",
    style: {
      fill: "#b16668"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Certificates--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.96 115.69 52.99 116.86 103.74 87.56 101.71 86.39 50.96 115.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.71 86.39 52.99 114.52 52.99 72.29 101.71 44.16 101.71 86.39",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.71 86.39 52.99 114.52 52.99 72.29 101.71 44.16 101.71 86.39",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.77,39.47,51,71.11v49.27l54.81-31.65Zm-2,48.09L53,116.86V72.29L103.74,43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.74 87.56 101.71 86.39 101.71 44.16 103.74 42.98 103.74 87.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.77 39.47 103.74 38.3 48.93 69.94 50.96 71.11 105.77 39.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.93 69.94 50.96 71.11 50.96 120.38 48.93 119.21 48.93 69.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,79.29c1.9-1.1,3.43-.21,3.43,2a7.55,7.55,0,0,1-3.43,5.93c-1.89,1.09-3.42.21-3.42-2A7.57,7.57,0,0,1,92.15,79.29Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,70.36l25.8-14.9c.72-.42,1.3-.08,1.3.74v.08a2.86,2.86,0,0,1-1.3,2.25L64.46,73.45c-.71.42-1.3.08-1.3-.75v-.09A2.91,2.91,0,0,1,64.46,70.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.38,82.1l34-19.6c.72-.42,1.3-.23,1.3.42a2.58,2.58,0,0,1-1.3,1.92l-34,19.62c-.71.42-1.29.23-1.28-.43A2.63,2.63,0,0,1,60.38,82.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.38,86.79l34-19.61c.72-.41,1.3-.22,1.3.42a2.61,2.61,0,0,1-1.3,1.93l-34,19.62c-.71.41-1.29.22-1.28-.43A2.61,2.61,0,0,1,60.38,86.79Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.38,91.47l34-19.61c.72-.41,1.3-.22,1.3.43a2.58,2.58,0,0,1-1.3,1.92l-34,19.62c-.71.42-1.29.22-1.28-.43A2.63,2.63,0,0,1,60.38,91.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.06,89.31a2,2,0,0,1-.85.23c-.73,0-.66-.74-.64-1.25,0-.23-.31-.59-.47-.28-.44.79-1,1.53-1.48,2.3-.29.47-.84,1.54-1.54,1.39-.28-.06-.38-.37-.38-.76a3.79,3.79,0,0,0,.45-2.12c0-.22-.4-.49-.51-.19a6.39,6.39,0,0,0-.44,2,12.9,12.9,0,0,1-1.1,1.63c-.24.31-.44.66-.7,1-.07.07-.19.25-.29.26s-.21-.1-.24-.26a1.67,1.67,0,0,1,.11-.69h0s0,0,0-.06h0c0-.23-.3-.57-.42-.28a10.2,10.2,0,0,1-2,3.32l-.13.11c0-.14,0-.27,0-.41a3.55,3.55,0,0,0-.16-.92c-.06-.15-.32-.38-.46-.18a15.53,15.53,0,0,1-2.26,3.12,3.81,3.81,0,0,1-.47.33c-.16-.08.08-.91.12-1,.09-.37.21-.73.33-1.09a4.06,4.06,0,0,0,.27-.9c0-.28-.43-.71-.52-.33,0,.15-.17.52-.31,1A24.92,24.92,0,0,1,70,98.36a7.45,7.45,0,0,1-2.65,2.55c-.3.16-.87.4-1.2.16s-.3-.65-.31-1a7.84,7.84,0,0,1,.32-2.35,14,14,0,0,0,2.94-2.08,10.43,10.43,0,0,0,2.23-2.46c.3-.55.48-1.44-.25-1.75-.51-.22-1.16.14-1.59.38A7,7,0,0,0,67.9,93.1a9.35,9.35,0,0,0-2,3.71c-.06.21-.15.49-.23.8a6.28,6.28,0,0,1-3.74.63c-.07,0-.1.15,0,.16a6.09,6.09,0,0,0,3.66-.35c-.33,1.42-.51,3.3.81,3.67s2.92-1.29,3.63-2.25a14.4,14.4,0,0,0,1.42-2.29,1.77,1.77,0,0,1,.12-.17c0,.66.13,1.14.78,1s1.24-1,1.6-1.53.65-1,1-1.47c.06.6.16,1.27.73,1.16s1-1.1,1.3-1.5.45-.7.64-1.06a2.14,2.14,0,0,0,.13.19c.47.5,1,0,1.34-.44.43-.56.91-1.16,1.32-1.8a1.12,1.12,0,0,0,.56.63c.73.34,1.41-.26,1.83-.79a16.47,16.47,0,0,0,1.36-2.2,1.06,1.06,0,0,0,.5.7,1.69,1.69,0,0,0,1.71-.11C86.51,89.68,86.3,89.19,86.06,89.31ZM70.17,92.15c.33-.17,1-.46,1.07.11a1.81,1.81,0,0,1-.46,1,11.88,11.88,0,0,1-2,2.1,17,17,0,0,1-2.47,1.89A8,8,0,0,1,70.17,92.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.96 115.69 132.99 116.86 183.74 87.56 181.71 86.39 130.96 115.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.71 86.39 132.99 114.52 132.99 72.29 181.71 44.16 181.71 86.39",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "181.71 86.39 132.99 114.52 132.99 72.29 181.71 44.16 181.71 86.39",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.77,39.47,131,71.11v49.27l54.81-31.65Zm-2,48.09L133,116.86V72.29L183.74,43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.74 87.56 181.71 86.39 181.71 44.16 183.74 42.98 183.74 87.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.77 39.47 183.74 38.3 128.93 69.94 130.96 71.11 185.77 39.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.93 69.94 130.96 71.11 130.96 120.38 128.93 119.21 128.93 69.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.16,79.29c1.89-1.1,3.42-.21,3.42,2a7.57,7.57,0,0,1-3.42,5.93c-1.9,1.09-3.43.21-3.43-2A7.55,7.55,0,0,1,172.16,79.29Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,70.36l25.81-14.9c.71-.42,1.29-.08,1.29.74v.08a2.87,2.87,0,0,1-1.29,2.25L144.46,73.45c-.71.42-1.29.08-1.29-.75v-.09A2.9,2.9,0,0,1,144.46,70.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.38,82.1l34-19.6c.72-.42,1.3-.23,1.3.42a2.58,2.58,0,0,1-1.3,1.92l-34,19.62c-.71.42-1.29.23-1.28-.43A2.63,2.63,0,0,1,140.38,82.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.38,86.79l34-19.61c.72-.41,1.3-.22,1.3.42a2.61,2.61,0,0,1-1.3,1.93l-34,19.62c-.71.41-1.29.22-1.28-.43A2.61,2.61,0,0,1,140.38,86.79Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.38,91.47l34-19.61c.72-.41,1.3-.22,1.3.43a2.58,2.58,0,0,1-1.3,1.92l-34,19.62c-.71.42-1.29.22-1.28-.43A2.63,2.63,0,0,1,140.38,91.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M166.06,89.31a1.93,1.93,0,0,1-.85.23c-.72,0-.66-.74-.64-1.25,0-.23-.31-.59-.47-.28-.44.79-1,1.53-1.48,2.3-.28.47-.84,1.54-1.53,1.39-.29-.06-.39-.37-.39-.76a3.79,3.79,0,0,0,.45-2.12c0-.22-.39-.49-.51-.19a6.39,6.39,0,0,0-.44,2,12.9,12.9,0,0,1-1.1,1.63c-.23.31-.44.66-.7,1-.06.07-.19.25-.29.26s-.21-.1-.24-.26a1.67,1.67,0,0,1,.11-.69h0a.14.14,0,0,0,0-.06h0c0-.23-.3-.57-.42-.28a10.2,10.2,0,0,1-2,3.32l-.13.11c0-.14,0-.27,0-.41a3.55,3.55,0,0,0-.16-.92c-.06-.15-.32-.38-.46-.18a15.15,15.15,0,0,1-2.26,3.12,3.18,3.18,0,0,1-.47.33c-.15-.08.09-.91.12-1,.09-.37.21-.73.33-1.09a4.06,4.06,0,0,0,.27-.9c0-.28-.43-.71-.52-.33,0,.15-.17.52-.31,1A23.83,23.83,0,0,1,150,98.36a7.45,7.45,0,0,1-2.65,2.55c-.3.16-.87.4-1.2.16s-.29-.65-.31-1a8.54,8.54,0,0,1,.32-2.35,14,14,0,0,0,2.94-2.08,10.22,10.22,0,0,0,2.23-2.46c.3-.55.48-1.44-.25-1.75-.51-.22-1.16.14-1.59.38a7,7,0,0,0-1.62,1.25,9.35,9.35,0,0,0-2,3.71c-.06.21-.15.49-.23.8a6.28,6.28,0,0,1-3.74.63c-.07,0-.1.15,0,.16a6.09,6.09,0,0,0,3.66-.35c-.33,1.42-.51,3.3.81,3.67s2.92-1.29,3.63-2.25a14.4,14.4,0,0,0,1.42-2.29,1.77,1.77,0,0,1,.12-.17c0,.66.13,1.14.78,1s1.24-1,1.61-1.53.64-1,1-1.47c.06.6.17,1.27.73,1.16s1-1.1,1.3-1.5.45-.7.64-1.06a2.14,2.14,0,0,0,.13.19c.47.5,1,0,1.34-.44.43-.56.91-1.16,1.32-1.8a1.12,1.12,0,0,0,.56.63c.73.34,1.41-.26,1.83-.79a16.47,16.47,0,0,0,1.36-2.2,1.06,1.06,0,0,0,.5.7,1.69,1.69,0,0,0,1.71-.11C166.52,89.68,166.3,89.19,166.06,89.31Zm-15.89,2.84c.34-.17,1-.46,1.07.11a1.87,1.87,0,0,1-.45,1,12.32,12.32,0,0,1-2,2.1,17,17,0,0,1-2.47,1.89A8,8,0,0,1,150.17,92.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorDetail);
export default __webpack_public_path__ + "static/media/DoctorDetail.57eb54a9d3406d107a59275b493915c2.svg";
export { ForwardRef as ReactComponent };